import React from 'react'
import { ProjectConfig } from '@/project-config'
import icPhoneActive from '../../assets/login/phone-active.svg'
import icCodeActive from '../../assets/login/code-active.svg'
import icPsdActive from '../../assets/login/psd-active.svg'
import LoginRight from './components/login-right'
import lessModule from './index.module.less'

export const loginTypeStorageKey = 'unified-login-type'
export { LOGIN_TYPE } from './components/login-left'

const recordNoUrl = 'https://beian.miit.gov.cn/'

const preloadImg = (src: string) => {
  const img = new Image()
  img.src = src
}
preloadImg(icPhoneActive)
preloadImg(icCodeActive)
preloadImg(icPsdActive)

const { LoginBoxComp } = ProjectConfig.loginLeft

export default function Login() {
  return (
    <div className={`${lessModule.login} login-custom-form`} id="login-form-override">
      <div className={lessModule.loginLeft}>
        <LoginBoxComp />
        <div className={lessModule.footerRecordNo}>
          <a rel="noopener noreferrer" target="_blank" href={recordNoUrl} className={lessModule.recordNoLink}>京ICP备2021033480号</a>
        </div>
      </div>
      <LoginRight />
    </div>
  )
}
